import { render, staticRenderFns } from "./cloudWords.vue?vue&type=template&id=ebc763e0&scoped=true&"
import script from "./cloudWords.vue?vue&type=script&lang=js&"
export * from "./cloudWords.vue?vue&type=script&lang=js&"
import style0 from "./cloudWords.vue?vue&type=style&index=0&id=ebc763e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc763e0",
  null
  
)

export default component.exports